import { withInstall } from '../../../utils/with-install'
import PointLight from './PointLight.vue'

export const ElAmapLocaPointLight = withInstall(PointLight)
export default ElAmapLocaPointLight
